import { makeAttachedBlock } from "../attachedBlock";

const block = makeAttachedBlock(
  "attached-connectors",
  "The user is referring to these connectors (by name):"
);

export const buildAttachedConnectorsBlock = block.build;
export const prependAttachedConnectors = block.prepend;
export const attachedConnectorNames = block.names;
export const stripAttachedConnectorsBlock = block.strip;
